// extracted by mini-css-extract-plugin
export var hidden = "_4e-1";
export var leftPanel = "_4e-2";
export var readonlyInspector = "_4e-3";
export var rightPanel = "_4e-0";